import { tuple } from '../_utils/type';
export var SelectSizes = tuple('large', 'middle', 'small'); // 选择框大小
export var BorderTypes = tuple('none', 'underline', 'bordered');
export var Modes = tuple('multiple', 'single');